<template>
    <div>
         <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
         <div id="camera">
        <div>
            <video ref="video" id="video" width="60%" height="60%" autoplay />
        </div>
        <div>
            <v-btn rounded color="primary" id="snap" v-on:click="capture()">Capture Photo</v-btn>
        </div>
        <canvas ref="canvas" id="canvas" width="100%" height="100%" />
        <template>
            <div class="text-center">
                <v-dialog v-model="dialog" width="500">
                    <v-card>
                        <v-card-text style="text-align: center; padding: 20px; color: red; font-size: 16px;"> Exam Not started or It is Ended </v-card-text>
                        <v-card-actions style="justify-content: center;">
                            <v-btn class="button" @click="dialog = false">
                                OK
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </div>
        </template>
        <template>
            <div class="text-center">
                <v-dialog v-model="dialog1" width="500">
                    <v-card>
                        <v-card-text style="text-align: center; padding: 20px; color: red; font-size: 16px;"> Image cpature Successfully you can start exam </v-card-text>
                        <v-card-actions style="justify-content: center;">
                            <v-btn class="button" @click="gohome()">
                                OK
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </div>
        </template>
        </div>
    </div>
</template>
<script>
    import axios from "axios";
    export default {
        name: "Camera",
        data() {
            return {
                dialog: false,
                dialog1: false,
                loader: false,
                msg: "",
                snackbar_msg: "",
                snackbar: false,
                color: "",
                video: {},
                canvas: {},
                captures: [],
                les: null,
                les_id:null,
                file: null,
                ettid_list:[],
                notsnap:false
            };
        },
        mounted() {
            this.les = this.$route.params.learner;
            this.video = this.$refs.video;
            if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
                navigator.mediaDevices.getUserMedia({ video: true }).then((stream) => {
                    video.srcObject = stream;
                    video.play();
                    video.onplay = function () {};
                    this.video.play();
                });
            }
            this.onload()
        },
        methods: {
            srcToFile(src, fileName, mimeType) {
                return fetch(src)
                    .then(function (res) {
                        return res.arrayBuffer();
                    })
                    .then(function (buf) {
                        return new File([buf], fileName, { type: mimeType });
                    });
            },
            capture() {
                //alert("in caprure");
                this.canvas = document.getElementById("canvas");
                this.canvas = this.$refs.canvas;
                var context = this.canvas.getContext("2d").drawImage(this.video, 0, 0, this.canvas.width, this.canvas.height);
                this.saveimage();
                // this.captures.push(canvas.toDataURL("image/webp"));
            },
            saveimage() {
               if(this.notsnap){
                   this.dialog = true;
                    return
               }
                var image;
                if (document.getElementById("canvas") != null) {
                    image = document.getElementById("canvas").toDataURL("image/png");
                }
                let fd = new FormData();
                fd.append("learner_id", this.les.id);
                fd.append("learner_exam_summary_id", this.les_id);
                this.srcToFile(image, "logo.png", "image/png")
                    .then(function (file) {
                        console.log("file....." + file.size);
                        fd.append("doc", file);
                        axios
                            .post("student/pushImage1", fd, { headers: { "Content-Type": "multipart/form-data" } })
                            .then(function () {
                                console.log("SUCCESS!!");
                            })
                            .catch(function () {
                                console.log("FAILURE!!");
                            });
                    })
                    .then((res) => {
                        this.dialog1 = true
                    }) 
                    .catch((error) => {
                    })
                    .finally(() => {
                    });
            },
            gohome(){
                 this.dialog1 = false
                this.$router.push({ name: "stud-start-exam"});
            },
            onload() {
                this.ettid_list = this.$route.params.ett_list;
                const formData = {
                    ett_id: this.ettid_list,
                };
                this.loader = true;
                axios
                    .post("/student/captureimage", formData)
                    .then((res) => {
                        if (res.data.snackbar == "Not-Started") {
                            this.notsnap = true
                            this.dialog = true;
                            return
                        }
                        else{
                            this.les_id = res.data.les_id
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {
                        this.loader = false;
                    });
            },
           
        },
        showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
    };
</script>
<style>
    #camera {
        text-align: center;
        color: #2c3e50;
    }
    #video {
        background-color: #000000;
    }
    #canvas {
        display: none;
    }
    li {
        display: inline;
        padding: 5px;
    }
</style>
